module.exports = __webpack_public_path__ + "img/4-3.13c05d35.png";